export default __webpack_public_path__ + "static/media/rally_car_3.85c1710d.svg";